






































import { Component, Vue, Prop } from 'vue-property-decorator';
import t from '@/i18n/translations';
import VueNumeric from 'vue-numeric'

@Component({
    components: {
        VueNumeric
    }
})

export default class SFInput extends Vue {
    @Prop({}) data: any;
    @Prop({}) showWarning: any;
    @Prop({}) value: any;
    @Prop({}) disabled: any;

    i18n = t['nl'];
}

